import { SingleChangeEvent } from "@dgs/core";
import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { applicationService } from "../../../shared/api/applicationService";
import { IApplicationCarFleetResource } from "../../../shared/types/application";

interface ReadyState {
	type: "ready";
	applicationSelect: {
		options: IApplicationCarFleetResource[];
		value: IApplicationCarFleetResource;
		onChange: (e: SingleChangeEvent<IApplicationCarFleetResource | undefined>) => void;
	};
}

interface LoadingState {
	type: "isLoading";
}

interface UnrenderableState {
	type: "unrenderable";
}

type State = ReadyState | LoadingState | UnrenderableState;

export const useCarFleetApplicationSelect = (): State => {
	const { data: applicationOptions = [], isLoading: isApplicationsLoading } = useQuery({
		queryKey: applicationService.keys.allCarFleet,
		queryFn: () => applicationService.allCarFleet().then((x) => x.data.data),
	});
	const [selectedCarFleetApplication, setSelectedCarFleetApplication] = useState<IApplicationCarFleetResource | null>(
		null,
	);

	useEffect(() => {
		if (!isApplicationsLoading && applicationOptions.length) {
			setSelectedCarFleetApplication(applicationOptions[0]);
		}
	}, [applicationOptions, isApplicationsLoading]);

	if (!isApplicationsLoading && !applicationOptions.length) {
		return {
			type: "unrenderable",
		};
	}

	if (!selectedCarFleetApplication || !applicationOptions) {
		return {
			type: "isLoading",
		};
	}

	return {
		type: "ready",
		applicationSelect: {
			options: applicationOptions,
			value: selectedCarFleetApplication,
			onChange: (e: SingleChangeEvent<IApplicationCarFleetResource | undefined>) =>
				e.target.value && setSelectedCarFleetApplication(e.target.value),
		},
	};
};
